export function getSmartVideoHTML(src, poster, autoplay = true){
  return `
    <smartvideo
      ${autoplay ? 'autoplay' : ''}
      controls
      src="${src}"
      poster="${poster}"
      width="1280"
      height="720"
      class="swarm-fluid"
      oncontextmenu="return false;">
    </smartvideo>
  `;
}
